import { Guid } from "guid-typescript";
/**
  * Generate a globally unique identifier
  * */
export function createGuid() {
    return Guid.create().toString();
}
